// extracted by mini-css-extract-plugin
export default {"container":"jK-z","modal":"kK-z","dimensions":"lK-z","brandName":"mK-z","productName":"nK-z","labelValue":"oK-z","recipientEmail":"pK-z","recommendedFit":"qK-z","hiddenField":"rK-z"};